export enum TicketStatusASM {

  IN_PROGRESS = "IN_PROGRESS",    //  SBM: CREATED, READY_FOR_TRANSMISSION, TRANSMITTED
  ACTIVE = "ACTIVE",         //  SBM: ACTIVE
  INACTIVE = "INACTIVE"        //  SBM: CANCELLED, TERMINATED

}
